import { render, staticRenderFns } from "./PopupReorderRequest.vue?vue&type=template&id=378c79b2&"
import script from "./PopupReorderRequest.vue?vue&type=script&lang=js&"
export * from "./PopupReorderRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports